 export const skillsData = [
    'HTML',
    'CSS',
    'Javascript',
    'TypeScript',
    'React',
    'Redux',
    'TailWind',
    'Bootstrap',
    "Git",
    "Cypress",
    "npm",
    "PostMan",
    "MaterialUI",
    'Canva',

]
export const skillsData2 = [
    'NodeJS',
    'MongoDB',
    "Express",
    "Mongoose",
]
export const skillsData3 = [
    
]
